import React, { useState } from 'react';
import DownloadRoundedIcon from 'components/atoms/icons/downloadRoundedIcon';
import withLoader from 'components/organisms/withLoader';
import { API_INTERACTION_STATUS } from 'services/dataService/resources';
import { Card, CardBody, Container, Table } from 'reactstrap';
import dataService from 'services/dataService';
import Toolbar from 'components/templates/rpm/practice/interactionStatus/toolbar';
import ActivityHeader from 'components/templates/rpm/practice/interactionStatus/activityHeader';
import ActivityRow from 'components/templates/rpm/practice/interactionStatus/activityRow';
import Pagination from 'components/molecules/pagination';
import { generateTimeRanges } from 'utils/dateHelpers';
import useTable from 'utils/useTable';
import { showResult } from 'utils';
import common from 'constants/common';
import forms from 'constants/forms';

const PER_PAGE = 100;
const timeRanges = generateTimeRanges();

const InteractionStatus = () => {
  const {
    data: { data: patients = [] },
    count,
    loading: reportLoading,
    page,
    setPage,
    filters,
    setFilters,
  } = useTable(API_INTERACTION_STATUS, PER_PAGE, {
    startDate: timeRanges[0].value[0],
    endDate: timeRanges[0].value[1],
    patientStatus: forms.patientStatuses[0]?.id,
  });

  const [downloadLoading, setDownloadLoading] = useState(false);

  const sendReport = async () => {
    if (downloadLoading) {
      return;
    }
    setDownloadLoading(true);
    const { error } = await dataService.createOne(
      API_INTERACTION_STATUS,
      filters,
    );
    setDownloadLoading(false);
    return showResult(error, common.submitSuccessTypes.sendReport);
  };

  return (
    <Container className="performance-review">
      <div>
        <Card className="card-border card--full-width card--margin-bottom">
          <CardBody>
            <div className="performance-review__header">
              <div className="performance-review__header--toolbox__wrapper">
                <h3 className="performance-review__header-title">
                  Report: Monthly Interaction Status
                </h3>
                <p style={{ display: 'inline-block', marginTop: '0px' }}>
                  This report only includes patients with one or more readings
                  for the month
                </p>
                <Toolbar
                  filters={filters}
                  setFilters={(newFilters) =>
                    setFilters({ ...filters, ...newFilters })
                  }
                  timeRanges={timeRanges}
                />
              </div>
              <div className="performance-review__header-icon">
                {withLoader(
                  downloadLoading,
                  <button onClick={sendReport}>
                    <DownloadRoundedIcon className="performance-review__header-icon-svg" />
                    <span>Download</span>
                  </button>,
                )}
              </div>
            </div>
            <div className="performance-review__table table-sticky-header">
              {withLoader(
                reportLoading,
                <>
                  <Table borderless cellSpacing="0" cellPadding="0">
                    <ActivityHeader />
                    <tbody>
                      {patients.map((patient, id) => (
                        <ActivityRow key={id} patient={patient} />
                      ))}
                    </tbody>
                  </Table>
                </>,
              )}
            </div>
            <div className="performance-review__table-button-pagination">
              <Pagination
                page={page}
                pageTotal={patients.length}
                itemsPerPage={PER_PAGE}
                total={count}
                handleFirstClick={() => setPage(1)}
                handleLastClick={() => setPage(Math.ceil(count / PER_PAGE))}
                handlePrevClick={() => setPage(page - 1)}
                handleNextClick={() => setPage(page + 1)}
                handleGoToPage={(pageNumber) => setPage(pageNumber)}
              />
            </div>
          </CardBody>
        </Card>
      </div>
    </Container>
  );
};

export default InteractionStatus;
